// extracted by mini-css-extract-plugin
export default {"mainButton":"styles_mainButton__q1g3T","primary":"styles_primary__eb7rK","secondary":"styles_secondary__Ghh09","buttonContainer":"styles_buttonContainer__awHmN"};